import React,{useEffect,useState} from 'react'
import * as render from './render.js'
import './viewer.css'
import './navbar.css'
import data from '../../resources/metadata.json'
import {useParams} from "react-router-dom";
export default function Viewer(props) {
    let { id } = useParams();

    let isMobile = false
    if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        isMobile = true
    }
    const [quality,setQuality] = useState(isMobile?{wSegments:500,hSegments:500}:{wSegments:1500,hSegments:1500})
    const totalMinted = 1676
    useEffect(() => {
        try{
            if (id <= totalMinted) {
                render.init(id - 1,quality.wSegments,quality.hSegments)                
            }
        }
        catch(error){}
        return () => {
            try {
                cancelAnimationFrame(render.animationFrameId)
                render.dispose()
                render.renderer.domElement = null;
                render.renderer.dispose()
            } catch (error) {}
        }
    }, [quality,id])

    

    const increaseQuality = () => {
        if (quality.wSegments < 500) setQuality({wSegments:quality.wSegments+100,hSegments:quality.hSegments+100})
        else if(quality.wSegments < 3500) setQuality({wSegments:quality.wSegments+500,hSegments:quality.hSegments+500})
    }
    const decreaseQuality = () => {
        if (quality.wSegments > 500) setQuality({wSegments:quality.wSegments-500,hSegments:quality.hSegments-500})            
        else if(quality.wSegments > 100) setQuality({wSegments:quality.wSegments-100,hSegments:quality.hSegments-100})            

    }

    try {
        document.onkeydown = checkKey;
        function checkKey(e) {
            e = e || window.event;
            if (e.keyCode === 38) {
                increaseQuality()
            }
            else if (e.keyCode === 40) {
                decreaseQuality()
            }
  
        }
      } catch (error) {}

    return (
        <div className = 'museumContainer'  id = 'museumContainer'>
            <canvas id = 'museumCanvas'></canvas>
        </div>
    )
}
